import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import { EditMenuLink } from "@builder/components/editable/editor/EditMenu";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { useAppSelector } from "@builder/store/store";
import { MenuNode } from "@common/build/types";

const StyleMenuTypography = ({ parent, title, stateMode }: EditableProps) => {
    const node = useAppSelector(getSelectedNode) as MenuNode;

    if (!node) return null;

    return (
        <SidebarCollapse title={title || "Menu"} parent={parent}>
            {node.menu.links.map((link, idx) => (
                <EditMenuLink key={link.id} idx={idx} menuLink={link} isOpen={idx === 0} mode={"typography"} nodeState={stateMode} />
            ))}
        </SidebarCollapse>
    );
};

export default StyleMenuTypography;
